import { Form, Spin, Typography } from "antd/es";
import { connect } from "react-redux";
import {
  Button,
  Header,
  HorizontalStack,
  Icon,
  Image,
  KCarousel,
  KCol,
  KDrawer,
  KGallery,
  KModal,
  KPanel,
  KRow,
  KTab,
  KTabItem,
  Label,
  TextInput,
  Tooltip,
  VerticalStack,
} from "../../components/web-components";
import {
  hideImportMappedExcelModal,
  hideIyzicoDrawer,
  hidePhotoTake,
  hideStripeDrawer,
  showImportMappedExcelModal,
  showIyzicoDrawer,
  showPhotoTake,
  showStripeDrawer,
} from "../../redux/modals/actions";
import { AppState } from "../../redux/root-reducer";
import { KuikaTabOrderProvider } from "../../shared/hoc/tab-order-provider";
import { withContext } from "../../shared/hoc/with-context";
import { withForm } from "../../shared/hoc/with-form";
import { withGoogleLogin } from "../../shared/hoc/with-google-login";
import { withHistory } from "../../shared/hoc/with-history";
import { withInlineOverlayNav } from "../../shared/hoc/with-inline-overlay-nav";
import { withScreenInput } from "../../shared/hoc/with-screen-input";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { ProoductDetail_ScreenBase } from "./prooductdetail-base";

import { InlineFormScope } from "../../routes/master-screen-wrapper";
import { ProoductDetail_Screen } from "../prooductdetail/prooductdetail";
import { SepetModal_Screen } from "../sepetmodal/sepetmodal";

declare let window: any;
const { Title, Paragraph, Text, Link } = Typography;
const menuMap = [];

class ProoductDetail_Screen extends ProoductDetail_ScreenBase {
  render() {
    if (this.state.isPageVisible === false) {
      return <></>;
    }
    return (
      <>
        <Spin spinning={this.state.spinnerCount > 0}>
          <KuikaTabOrderProvider>
            <Form
              form={this.props.form}
              name="basic"
              initialValues={{
                prooductdetail_319766_value:
                  "08e98b84-9e22-454f-6e1c-08dce94fb2ac",
                prooductdetail_647404_value: undefined,
                prooductdetail_9435_value:
                  "f4b5fbbd-9e25-402c-9581-08dd8e436860",
                prooductdetail_270791_value:
                  "6ba68c00-24bc-4d8c-6d9a-08de0b486d08",
                prooductdetail_9730_value: undefined,
              }}
              onValuesChange={(changedValues, allValues) => {
                this.clearFieldValidation(changedValues);
              }}
            >
              <div
                style={
                  {
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "100%",
                  } as any
                }
              >
                <Header
                  key="-2"
                  id="prooductdetail_header"
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      backgroundColor: "rgba(255, 255, 255, 1)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "left",
                      paddingTop: 0,
                      fontFamily: "Poppins",
                      fontWeight: 500,
                      fontSize: "14px",
                      color: "rgba(68, 68, 68, 1)",
                    } as any
                  }
                >
                  <KRow
                    key="725640"
                    id="725640"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        backgroundColor: "rgba(255, 255, 255, 1)",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain",
                        backgroundPosition: "left",
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KCol
                      key="12549"
                      id="12549"
                      xs={3}
                      sm={3}
                      md={3}
                      lg={3}
                      xl={3}
                      xxl={3}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KRow
                        key="479346"
                        id="479346"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "contain",
                            backgroundPosition: "left",
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KCol
                          key="408776"
                          id="408776"
                          xs={24}
                          sm={24}
                          md={24}
                          lg={24}
                          xl={24}
                          xxl={24}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(255, 255, 255, 1)",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "contain",
                              backgroundPosition: "left",
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "flex-start",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        ></KCol>
                      </KRow>
                    </KCol>
                    <KCol
                      key="445597"
                      id="445597"
                      xs={18}
                      sm={18}
                      md={18}
                      lg={18}
                      xl={18}
                      xxl={18}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KRow
                        key="788330"
                        id="788330"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderTopLeftRadius: 10,
                            borderTopRightRadius: 10,
                            borderBottomRightRadius: 10,
                            borderBottomLeftRadius: 10,
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            boxShadow:
                              "3px 3px 20px 0px rgba(217, 217, 217, 0.49)",
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KCol
                          key="516034"
                          id="516034"
                          xs={6}
                          sm={6}
                          md={6}
                          lg={6}
                          xl={6}
                          xxl={6}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "flex-start",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Form.Item
                            className="kFormItem"
                            name="prooductdetail_319766_value"
                          >
                            <Image
                              key="319766"
                              id="319766"
                              onClick={(e?: any) => {
                                if (e && e.stopPropagation) e.stopPropagation();
                                this.prooductDetailComponent_319766_onClick();
                              }}
                              showCursorPointer
                              zoomOnClick={false}
                              imageFit="fit"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  width: "120px",
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "inline",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "14px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            ></Image>
                          </Form.Item>
                        </KCol>
                        <KCol
                          key="964707"
                          id="964707"
                          xs={6}
                          sm={6}
                          md={6}
                          lg={6}
                          xl={6}
                          xxl={6}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(255, 255, 255, 1)",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "contain",
                              backgroundPosition: "left",
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "flex-start",
                              textAlign: "-webkit-center",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        ></KCol>
                        <KCol
                          key="409806"
                          id="409806"
                          xs={11}
                          sm={11}
                          md={11}
                          lg={11}
                          xl={11}
                          xxl={11}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 25,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "flex-start",
                              textAlign: "-webkit-right",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KRow
                            key="901190"
                            id="901190"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "14px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <KCol
                              key="582793"
                              id="582793"
                              xs={22}
                              sm={22}
                              md={22}
                              lg={22}
                              xl={22}
                              xxl={22}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  textAlign: "-webkit-right",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "14px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <Form.Item
                                className="kFormItem"
                                name="prooductdetail_647404_value"
                              >
                                <TextInput
                                  key="647404"
                                  id="647404"
                                  onPressEnter={(e?: any) => {
                                    if (e && e.stopPropagation)
                                      e.stopPropagation();
                                    this.prooductDetailComponent_647404_onPressEnter();
                                  }}
                                  kuikaRef={
                                    this
                                      .prooductdetail_647404_value_kuikaTextInputRef
                                  }
                                  placeholder={ReactSystemFunctions.translate(
                                    this.ml,
                                    647404,
                                    "placeholder",
                                    this.defaultML
                                  )}
                                  allowClear={false}
                                  bordered={true}
                                  disabled={false}
                                  type="text"
                                  iconColor="rgba(0, 0, 0, 1)"
                                  formatter="None"
                                  isCharOnly={false}
                                  autoComplete={true}
                                  inputMode="all"
                                  speechToText={false}
                                  style={
                                    {
                                      borderTopLeftRadius: 10,
                                      borderTopRightRadius: 10,
                                      borderBottomRightRadius: 10,
                                      borderBottomLeftRadius: 10,
                                      borderTopWidth: 1,
                                      borderRightWidth: 1,
                                      borderBottomWidth: 1,
                                      borderLeftWidth: 1,
                                      borderColor: "rgba(218, 218, 218, 1)",
                                      borderStyle: "solid",
                                      boxShadow:
                                        "0px 3px 10px 0px rgba(217, 217, 217, 0.37)",
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "block",
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></TextInput>
                              </Form.Item>
                            </KCol>
                            <KCol
                              key="178991"
                              id="178991"
                              xs={2}
                              sm={2}
                              md={2}
                              lg={2}
                              xl={2}
                              xxl={2}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  textAlign: "-webkit-center",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "14px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <Icon
                                key="227193"
                                id="227193"
                                onClick={(e?: any) => {
                                  if (e && e.stopPropagation)
                                    e.stopPropagation();
                                  this.prooductDetailComponent_227193_onClick();
                                }}
                                showCursorPointer
                                iconName="search"
                                style={
                                  {
                                    borderTopLeftRadius: 10,
                                    borderTopRightRadius: 10,
                                    borderBottomRightRadius: 10,
                                    borderBottomLeftRadius: 10,
                                    borderTopWidth: 1,
                                    borderRightWidth: 1,
                                    borderBottomWidth: 1,
                                    borderLeftWidth: 1,
                                    borderColor: "rgba(218, 218, 218, 1)",
                                    borderStyle: "solid",
                                    boxShadow:
                                      "0px 0px 9px 0px rgba(217, 217, 217, 1)",
                                    backgroundColor: "rgba(252, 17, 22, 1)",
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    display: "inline",
                                    fontFamily: "Poppins",
                                    fontWeight: 500,
                                    fontSize: "20px",
                                    color: "rgba(255, 255, 255, 1)",
                                    letterSpacing: "1px",
                                  } as any
                                }
                              ></Icon>
                            </KCol>
                          </KRow>
                        </KCol>
                        <KCol
                          key="427503"
                          id="427503"
                          xs={1}
                          sm={1}
                          md={1}
                          lg={1}
                          xl={1}
                          xxl={1}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "flex-start",
                              textAlign: "-webkit-right",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Icon
                            key="231436"
                            id="231436"
                            onClick={(e?: any) => {
                              if (e && e.stopPropagation) e.stopPropagation();
                              this.prooductDetailComponent_231436_onClick();
                            }}
                            showCursorPointer
                            iconName="close"
                            style={
                              {
                                borderTopLeftRadius: 10,
                                borderTopRightRadius: 10,
                                borderBottomRightRadius: 10,
                                borderBottomLeftRadius: 10,
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                boxShadow:
                                  "0px 0px 9px 0px rgba(217, 217, 217, 1)",
                                backgroundColor: "rgba(252, 17, 22, 1)",
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "22px",
                                color: "rgba(255, 255, 255, 1)",
                                letterSpacing: "1px",
                              } as any
                            }
                          ></Icon>
                        </KCol>
                      </KRow>
                    </KCol>
                    <KCol
                      key="815824"
                      id="815824"
                      xs={3}
                      sm={3}
                      md={3}
                      lg={3}
                      xl={3}
                      xxl={3}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    ></KCol>
                  </KRow>
                </Header>
                <div
                  key="-1"
                  id="prooductdetail_body"
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "left",
                      display: "block",
                    } as any
                  }
                >
                  <KRow
                    key="925471"
                    id="925471"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KCol
                      key="213388"
                      id="213388"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={3}
                      xxl={3}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    ></KCol>
                    <KCol
                      key="753857"
                      id="753857"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={18}
                      xxl={18}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KRow
                        key="491933"
                        id="491933"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderTopLeftRadius: 10,
                            borderTopRightRadius: 10,
                            borderBottomRightRadius: 10,
                            borderBottomLeftRadius: 10,
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            boxShadow:
                              "3px 3px 20px 0px rgba(217, 217, 217, 0.49)",
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KCol
                          key="117141"
                          id="117141"
                          xs={24}
                          sm={24}
                          md={24}
                          lg={24}
                          xl={24}
                          xxl={24}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(0, 0, 0, 0)",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KRow
                            key="4839"
                            id="4839"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "14px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <KCol
                              key="621903"
                              id="621903"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={24}
                              xxl={24}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 8,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "14px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <KRow
                                key="26788"
                                id="26788"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderTopLeftRadius: 25,
                                    borderTopRightRadius: 25,
                                    borderBottomRightRadius: 25,
                                    borderBottomLeftRadius: 25,
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    backgroundColor: "rgba(255, 255, 255, 1)",
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: "contain",
                                    backgroundPosition: "left",
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Poppins",
                                    fontWeight: 500,
                                    fontSize: "14px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <KCol
                                  key="624184"
                                  id="624184"
                                  xs={24}
                                  sm={12}
                                  md={12}
                                  lg={12}
                                  xl={12}
                                  xxl={12}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderTopLeftRadius: 25,
                                      borderTopRightRadius: 25,
                                      borderBottomRightRadius: 25,
                                      borderBottomLeftRadius: 25,
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 0,
                                      alignItems: "center",
                                      textAlign: "-webkit-center",
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <Form.Item
                                    className="kFormItem"
                                    name="prooductdetail_67122_value"
                                    noStyle
                                  >
                                    <KCarousel
                                      key="67122"
                                      id="67122"
                                      visibility={this.state.isComp67122Visible}
                                      kuikaRef={
                                        this
                                          .prooductdetail_67122_value_kuikaCarouselRef
                                      }
                                      nodatafoundmessage={ReactSystemFunctions.translate(
                                        this.ml,
                                        67122,
                                        "nodatafoundmessage",
                                        this.defaultML
                                      )}
                                      dataSource={this.state.GetStokResim}
                                      fade={false}
                                      hoverFontColor="rgba(255, 255, 255, 1)"
                                      hoverBgColor="rgba(255, 255, 255, 1)"
                                      slidesToScroll={1}
                                      slidesToShow={1}
                                      swipe={false}
                                      vertical={false}
                                      pauseOnDotsHover={true}
                                      autoplay={true}
                                      autoplaySpeed={2000}
                                      dots={true}
                                      showNoDataFoundImage={true}
                                      showPageIndicator={false}
                                      style={
                                        {
                                          borderTopLeftRadius: 25,
                                          borderTopRightRadius: 25,
                                          borderBottomRightRadius: 25,
                                          borderBottomLeftRadius: 25,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          maxHeight: "40vh",
                                          textAlign: "-webkit-center",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="264965"
                                        id="264965"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="772131"
                                          id="772131"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-center",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <Form.Item
                                            className="kFormItem"
                                            name="prooductdetail_734238_value"
                                          >
                                            <Image
                                              key="734238"
                                              id="734238"
                                              value="[datafield:resim]"
                                              placeHolderImage="f4b5fbbd-9e25-402c-9581-08dd8e436860"
                                              zoomOnClick={true}
                                              imageFit="fit"
                                              style={
                                                {
                                                  borderTopLeftRadius: 15,
                                                  borderTopRightRadius: 15,
                                                  borderBottomRightRadius: 15,
                                                  borderBottomLeftRadius: 15,
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  width: "350px",
                                                  height: "350px",
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            ></Image>
                                          </Form.Item>
                                        </KCol>
                                      </KRow>
                                    </KCarousel>
                                  </Form.Item>

                                  <Form.Item
                                    className="kFormItem"
                                    name="prooductdetail_9435_value"
                                  >
                                    <Image
                                      key="9435"
                                      id="9435"
                                      visibility={this.state.isComp9435Visible}
                                      zoomOnClick={false}
                                      imageFit="fit"
                                      style={
                                        {
                                          borderTopLeftRadius: 15,
                                          borderTopRightRadius: 15,
                                          borderBottomRightRadius: 15,
                                          borderBottomLeftRadius: 15,
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          width: "350px",
                                          height: "350px",
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "inline",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "14px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    ></Image>
                                  </Form.Item>
                                </KCol>
                                <KCol
                                  key="8447"
                                  id="8447"
                                  xs={24}
                                  sm={12}
                                  md={12}
                                  lg={12}
                                  xl={12}
                                  xxl={12}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 8,
                                      paddingBottom: 0,
                                      paddingLeft: 8,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="433263"
                                    id="433263"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 8,
                                        paddingBottom: 0,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="267270"
                                      id="267270"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderBottomWidth: 1,
                                          borderColor: "rgba(217, 217, 217, 1)",
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "14px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="339721"
                                        id="339721"
                                        direction="vertical"
                                        size={5}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <HorizontalStack
                                          key="88487"
                                          id="88487"
                                          direction="horizontal"
                                          size={12}
                                          overflowX="auto"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="685473"
                                            id="685473"
                                            value={
                                              this.state.GetStokDetayStokBilgileri?.at?.(
                                                0
                                              )?.birlesmisstok ?? undefined
                                            }
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 600,
                                                fontSize: "14px",
                                                color: "rgba(0, 0, 0, 1)",
                                              } as any
                                            }
                                          ></Label>
                                          <Tooltip
                                            key="583835"
                                            id="583835"
                                            visibility={
                                              this.state.isComp583835Visible
                                            }
                                            title={
                                              this.state.GetStokDetayStokBilgileri?.at?.(
                                                0
                                              )?.adetBazliFiyatAciklama ??
                                              undefined
                                            }
                                            placement="top"
                                            style={
                                              {
                                                borderTopLeftRadius: 4,
                                                borderTopRightRadius: 4,
                                                borderBottomRightRadius: 4,
                                                borderBottomLeftRadius: 4,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor:
                                                  "rgba(218, 218, 218, 1)",
                                                borderStyle: "solid",
                                                backgroundColor:
                                                  "rgba(255, 255, 255, 1)",
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "left",
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                fontFamily: "Poppins",
                                                fontWeight: 600,
                                                fontSize: "12px",
                                                color: "rgba(155, 155, 155, 1)",
                                                lineHeight: "20px",
                                              } as any
                                            }
                                          >
                                            <Form.Item
                                              className="kFormItem"
                                              name="prooductdetail_270791_value"
                                            >
                                              <Image
                                                key="270791"
                                                id="270791"
                                                zoomOnClick={false}
                                                imageFit="fit"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 5,
                                                    width: "85px",
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></Image>
                                            </Form.Item>
                                          </Tooltip>
                                        </HorizontalStack>
                                        <Label
                                          key="461242"
                                          id="461242"
                                          value={
                                            this.state.GetStokDetayStokBilgileri?.at?.(
                                              0
                                            )?.stoK_KODU ?? undefined
                                          }
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Montserrat",
                                              fontWeight: 600,
                                              fontSize: "12px",
                                              color: "rgba(0, 0, 0, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Label
                                          key="61661"
                                          id="61661"
                                          value={
                                            this.state.GetStokDetayStokBilgileri?.at?.(
                                              -1
                                            )?.barkoD1 ?? undefined
                                          }
                                          writingMode="horizontal"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Montserrat",
                                              fontWeight: 500,
                                              fontSize: "11px",
                                              color: "rgba(0, 0, 0, 1)",
                                            } as any
                                          }
                                        ></Label>
                                      </VerticalStack>
                                    </KCol>
                                    <KCol
                                      key="87858"
                                      id="87858"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "14px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="620587"
                                        id="620587"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderBottomWidth: 1,
                                            borderColor:
                                              "rgba(144, 144, 144, 0.27)",
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 0,
                                            paddingBottom: 8,
                                            paddingLeft: 0,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="719501"
                                          id="719501"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 20,
                                              paddingRight: 0,
                                              paddingBottom: 20,
                                              paddingLeft: 0,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KPanel
                                            key="107059"
                                            id="107059"
                                            scrolling="vertical"
                                            scrollBackColor="rgba(252, 17, 22, 1)"
                                            scrollWidth={3}
                                            scrollRadius={true}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                maxHeight: "15vh",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <KGallery
                                              key="264271"
                                              id="264271"
                                              kuikaRef={
                                                this
                                                  .prooductdetail_264271_value_kuikaGalleryViewRef
                                              }
                                              nodatafoundmessage={ReactSystemFunctions.translate(
                                                this.ml,
                                                264271,
                                                "nodatafoundmessage",
                                                this.defaultML
                                              )}
                                              dataSource={
                                                this.state.GetWebStokOem
                                              }
                                              loading={false}
                                              phoneColumnsCount={1}
                                              tabletColumnsCount={2}
                                              desktopColumnsCount={2}
                                              hoverFontColor="black"
                                              hoverBgColor="white"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              showNoDataFoundImage={false}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="656360"
                                                id="656360"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 5,
                                                    paddingRight: 8,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="294903"
                                                  id="294903"
                                                  xs={12}
                                                  sm={12}
                                                  md={12}
                                                  lg={12}
                                                  xl={12}
                                                  xxl={12}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 10,
                                                      borderBottomLeftRadius: 10,
                                                      borderTopWidth: 1,
                                                      borderBottomWidth: 1,
                                                      borderLeftWidth: 1,
                                                      borderColor:
                                                        "rgba(217, 217, 217, 0.29)",
                                                      borderStyle: "solid",
                                                      borderRightWidth: 0,
                                                      backgroundColor:
                                                        "rgba(0, 0, 0, 1)",
                                                      backgroundRepeat:
                                                        "no-repeat",
                                                      backgroundSize: "contain",
                                                      backgroundPosition:
                                                        "left",
                                                      paddingRight: 0,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="119578"
                                                    id="119578"
                                                    value="[datafield:musterI_MARKA]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 7,
                                                        paddingRight: 7,
                                                        paddingBottom: 7,
                                                        paddingLeft: 7,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 600,
                                                        fontSize: "9px",
                                                        color:
                                                          "rgba(255, 255, 255, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KCol>
                                                <KCol
                                                  key="873976"
                                                  id="873976"
                                                  xs={12}
                                                  sm={12}
                                                  md={12}
                                                  lg={12}
                                                  xl={12}
                                                  xxl={12}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderTopRightRadius: 15,
                                                      borderBottomRightRadius: 15,
                                                      borderTopWidth: 1,
                                                      borderRightWidth: 1,
                                                      borderBottomWidth: 1,
                                                      borderColor:
                                                        "rgba(217, 217, 217, 0.29)",
                                                      borderStyle: "solid",
                                                      borderLeftWidth: 0,
                                                      paddingLeft: 0,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="986010"
                                                    id="986010"
                                                    value="[datafield:oeM_NO]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 7,
                                                        paddingRight: 7,
                                                        paddingBottom: 7,
                                                        paddingLeft: 7,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 400,
                                                        fontSize: "10px",
                                                        color:
                                                          "rgba(0, 0, 0, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KCol>
                                              </KRow>
                                            </KGallery>
                                          </KPanel>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="711881"
                                        id="711881"
                                        visibility={
                                          this.state.isComp711881Visible
                                        }
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="87746"
                                          id="87746"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 0,
                                              paddingBottom: 8,
                                              paddingLeft: 0,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KPanel
                                            key="93766"
                                            id="93766"
                                            scrolling="vertical"
                                            scrollBackColor="rgba(252, 17, 22, 1)"
                                            scrollWidth={4}
                                            scrollRadius={false}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                maxHeight: "400px",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <KRow
                                              key="131940"
                                              id="131940"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="228131"
                                                id="228131"
                                                xs={24}
                                                sm={24}
                                                md={24}
                                                lg={24}
                                                xl={24}
                                                xxl={24}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 20,
                                                    paddingRight: 0,
                                                    paddingBottom: 20,
                                                    paddingLeft: 0,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <KGallery
                                                  key="102381"
                                                  id="102381"
                                                  kuikaRef={
                                                    this
                                                      .prooductdetail_102381_value_kuikaGalleryViewRef
                                                  }
                                                  nodatafoundmessage={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    102381,
                                                    "nodatafoundmessage",
                                                    this.defaultML
                                                  )}
                                                  dataSource={
                                                    this.state.GetFarkliOlcuStok
                                                  }
                                                  loading={false}
                                                  phoneColumnsCount={1}
                                                  tabletColumnsCount={2}
                                                  desktopColumnsCount={1}
                                                  hoverFontColor="black"
                                                  hoverBgColor="white"
                                                  horizontalGutter={0}
                                                  verticalGutter={0}
                                                  showNoDataFoundImage={false}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <KRow
                                                    key="674422"
                                                    id="674422"
                                                    onClick={(e?: any) => {
                                                      if (
                                                        e &&
                                                        e.stopPropagation
                                                      )
                                                        e.stopPropagation();
                                                      this.prooductDetailComponent_674422_onClick();
                                                    }}
                                                    showCursorPointer
                                                    align="top"
                                                    justify="start"
                                                    horizontalGutter={0}
                                                    verticalGutter={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 0,
                                                        paddingBottom: 8,
                                                        paddingLeft: 0,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <KCol
                                                      key="837211"
                                                      id="837211"
                                                      xs={12}
                                                      sm={12}
                                                      md={12}
                                                      lg={12}
                                                      xl={12}
                                                      xxl={12}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderTopLeftRadius: 10,
                                                          borderBottomLeftRadius: 10,
                                                          borderTopWidth: 1,
                                                          borderBottomWidth: 1,
                                                          borderLeftWidth: 1,
                                                          borderColor:
                                                            "rgba(217, 217, 217, 0.29)",
                                                          borderStyle: "solid",
                                                          borderRightWidth: 0,
                                                          backgroundColor:
                                                            "rgba(0, 0, 0, 1)",
                                                          backgroundRepeat:
                                                            "no-repeat",
                                                          backgroundSize:
                                                            "contain",
                                                          backgroundPosition:
                                                            "left",
                                                          paddingRight: 0,
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Label
                                                        key="727129"
                                                        id="727129"
                                                        value="[datafield:farklI_OLCU_STOGU]"
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 7,
                                                            paddingRight: 7,
                                                            paddingBottom: 7,
                                                            paddingLeft: 7,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 600,
                                                            fontSize: "10px",
                                                            color:
                                                              "rgba(255, 255, 255, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                    </KCol>
                                                    <KCol
                                                      key="496900"
                                                      id="496900"
                                                      xs={12}
                                                      sm={12}
                                                      md={12}
                                                      lg={12}
                                                      xl={12}
                                                      xxl={12}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderTopRightRadius: 10,
                                                          borderBottomRightRadius: 10,
                                                          borderTopWidth: 1,
                                                          borderRightWidth: 1,
                                                          borderBottomWidth: 1,
                                                          borderColor:
                                                            "rgba(217, 217, 217, 0.29)",
                                                          borderStyle: "solid",
                                                          borderLeftWidth: 0,
                                                          paddingLeft: 0,
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Label
                                                        key="357695"
                                                        id="357695"
                                                        value="[datafield:birlesmisstok]"
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 7,
                                                            paddingRight: 7,
                                                            paddingBottom: 7,
                                                            paddingLeft: 7,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(0, 0, 0, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                    </KCol>
                                                  </KRow>
                                                </KGallery>
                                              </KCol>
                                            </KRow>
                                          </KPanel>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="880600"
                                        id="880600"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 5,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="255175"
                                          id="255175"
                                          xs={8}
                                          sm={8}
                                          md={8}
                                          lg={8}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              alignItems: "center",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="313997"
                                            id="313997"
                                            value={
                                              this.props.screenInputs
                                                .paraBirimi ??
                                              this.props.screenInputs.parabirimi
                                            }
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 5,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 700,
                                                fontSize: "18px",
                                                color: "rgba(245, 34, 45, 1)",
                                              } as any
                                            }
                                          ></Label>
                                          <Label
                                            key="651857"
                                            id="651857"
                                            value={
                                              this.state.GetStokDetayStokBilgileri?.at?.(
                                                0
                                              )?.fiyat ?? undefined
                                            }
                                            formatter="money"
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Montserrat",
                                                fontWeight: 700,
                                                fontSize: "20px",
                                                color: "rgba(245, 34, 45, 1)",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="478723"
                                          id="478723"
                                          xs={16}
                                          sm={16}
                                          md={16}
                                          lg={16}
                                          xl={16}
                                          xxl={16}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KRow
                                            key="546155"
                                            id="546155"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 0,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="592880"
                                              id="592880"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={24}
                                              xxl={24}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 0,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-right",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <HorizontalStack
                                                key="3601"
                                                id="3601"
                                                direction="horizontal"
                                                size={12}
                                                overflowX="auto"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Button
                                                  key="721927"
                                                  id="721927"
                                                  onClick={(e?: any) => {
                                                    if (e && e.stopPropagation)
                                                      e.stopPropagation();
                                                    this.prooductDetailComponent_721927_onClick();
                                                  }}
                                                  showCursorPointer
                                                  visibility={
                                                    this.state
                                                      .isComp721927Visible
                                                  }
                                                  label={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    721927,
                                                    "label",
                                                    this.defaultML
                                                  )}
                                                  size="middle"
                                                  loading={false}
                                                  ghost={false}
                                                  block={false}
                                                  htmlType="button"
                                                  icon="sell"
                                                  iconPosition="left"
                                                  danger={false}
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 10,
                                                      borderTopRightRadius: 10,
                                                      borderBottomRightRadius: 10,
                                                      borderBottomLeftRadius: 10,
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      backgroundColor:
                                                        "rgba(0, 0, 0, 1)",
                                                      backgroundRepeat:
                                                        "no-repeat",
                                                      backgroundSize: "contain",
                                                      backgroundPosition:
                                                        "left",
                                                      paddingTop: 8,
                                                      paddingRight: 16,
                                                      paddingBottom: 8,
                                                      paddingLeft: 16,
                                                      alignItems: "center",
                                                      textAlign:
                                                        "-webkit-center",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(255, 255, 255, 1)",
                                                      lineHeight: "22px",
                                                    } as any
                                                  }
                                                ></Button>
                                                <Button
                                                  key="680501"
                                                  id="680501"
                                                  onClick={(e?: any) => {
                                                    if (e && e.stopPropagation)
                                                      e.stopPropagation();
                                                    this.prooductDetailComponent_680501_onClick();
                                                  }}
                                                  showCursorPointer
                                                  label={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    680501,
                                                    "label",
                                                    this.defaultML
                                                  )}
                                                  size="middle"
                                                  loading={false}
                                                  ghost={false}
                                                  block={false}
                                                  htmlType="button"
                                                  icon="add_shopping_cart"
                                                  iconPosition="left"
                                                  danger={false}
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 10,
                                                      borderTopRightRadius: 10,
                                                      borderBottomRightRadius: 10,
                                                      borderBottomLeftRadius: 10,
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      backgroundColor:
                                                        "rgba(252, 17, 22, 1)",
                                                      backgroundRepeat:
                                                        "no-repeat",
                                                      backgroundSize: "contain",
                                                      backgroundPosition:
                                                        "left",
                                                      paddingTop: 8,
                                                      paddingRight: 16,
                                                      paddingBottom: 8,
                                                      paddingLeft: 16,
                                                      alignItems: "center",
                                                      textAlign:
                                                        "-webkit-center",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(255, 255, 255, 1)",
                                                      lineHeight: "22px",
                                                    } as any
                                                  }
                                                ></Button>
                                              </HorizontalStack>
                                            </KCol>
                                          </KRow>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="922785"
                                        id="922785"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      ></KRow>
                                    </KCol>
                                  </KRow>
                                </KCol>
                              </KRow>
                            </KCol>
                          </KRow>
                        </KCol>
                      </KRow>
                    </KCol>
                    <KCol
                      key="691326"
                      id="691326"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={3}
                      xxl={3}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    ></KCol>
                  </KRow>
                  <KRow
                    key="688257"
                    id="688257"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KCol
                      key="389775"
                      id="389775"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={3}
                      xxl={3}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    ></KCol>
                    <KCol
                      key="458887"
                      id="458887"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={18}
                      xxl={18}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KRow
                        key="748498"
                        id="748498"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderTopLeftRadius: 10,
                            borderTopRightRadius: 10,
                            borderBottomRightRadius: 10,
                            borderBottomLeftRadius: 10,
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            boxShadow:
                              "3px 3px 20px 0px rgba(217, 217, 217, 0.49)",
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KCol
                          key="533166"
                          id="533166"
                          xs={24}
                          sm={24}
                          md={24}
                          lg={24}
                          xl={24}
                          xxl={24}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(0, 0, 0, 0)",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KRow
                            key="794599"
                            id="794599"
                            align="top"
                            justify="start"
                            horizontalGutter={0}
                            verticalGutter={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "14px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <KCol
                              key="80464"
                              id="80464"
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={24}
                              xxl={24}
                              order={0}
                              pull={0}
                              push={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "14px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <KRow
                                key="257348"
                                id="257348"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Poppins",
                                    fontWeight: 500,
                                    fontSize: "14px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <KCol
                                  key="332082"
                                  id="332082"
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <Form.Item
                                    className="kFormItem"
                                    name="prooductdetail_9730_value"
                                    noStyle
                                  >
                                    <KTab
                                      key="9730"
                                      id="9730"
                                      type="line"
                                      size="default"
                                      tabPosition="top"
                                      selectedTabColor="rgba(252, 17, 22, 1)"
                                      justifiedTabTitles={false}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "inline",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "14px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    >
                                      <KTabItem
                                        key={536371}
                                        id="536371"
                                        visibility={
                                          this.state.isComp536371Visible
                                        }
                                        tab={ReactSystemFunctions.translate(
                                          this.ml,
                                          536371,
                                          "tab",
                                          this.defaultML
                                        )}
                                        forceRender={true}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            backgroundColor:
                                              "rgba(255, 255, 255, 1)",
                                            backgroundRepeat: "no-repeat",
                                            backgroundSize: "contain",
                                            backgroundPosition: "left",
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KGallery
                                          key="251456"
                                          id="251456"
                                          kuikaRef={
                                            this
                                              .prooductdetail_251456_value_kuikaGalleryViewRef
                                          }
                                          nodatafoundmessage={ReactSystemFunctions.translate(
                                            this.ml,
                                            251456,
                                            "nodatafoundmessage",
                                            this.defaultML
                                          )}
                                          dataSource={this.state.GetTamirTakim}
                                          loading={false}
                                          phoneColumnsCount={1}
                                          tabletColumnsCount={2}
                                          desktopColumnsCount={6}
                                          hoverFontColor="black"
                                          hoverBgColor="white"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          showNoDataFoundImage={false}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KRow
                                            key="878172"
                                            id="878172"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="443950"
                                              id="443950"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={24}
                                              xxl={24}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 0,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="927562"
                                                id="927562"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="940099"
                                                  id="940099"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={24}
                                                  xxl={24}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 15,
                                                      borderTopRightRadius: 15,
                                                      borderBottomRightRadius: 15,
                                                      borderBottomLeftRadius: 15,
                                                      borderColor:
                                                        "rgba(72, 72, 72, 1)",
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 0,
                                                      alignItems: "flex-start",
                                                      textAlign: "-webkit-left",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <KRow
                                                    key="312950"
                                                    id="312950"
                                                    align="top"
                                                    justify="start"
                                                    horizontalGutter={0}
                                                    verticalGutter={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <KCol
                                                      key="129773"
                                                      id="129773"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={24}
                                                      xxl={24}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderTopLeftRadius: 15,
                                                          borderTopRightRadius: 15,
                                                          borderBottomRightRadius: 15,
                                                          borderBottomLeftRadius: 15,
                                                          borderTopWidth: 1,
                                                          borderRightWidth: 1,
                                                          borderBottomWidth: 1,
                                                          borderLeftWidth: 1,
                                                          borderColor:
                                                            "rgba(217, 217, 217, 0.37)",
                                                          borderStyle: "solid",
                                                          paddingTop: 0,
                                                          paddingRight: 8,
                                                          paddingBottom: 8,
                                                          paddingLeft: 8,
                                                          alignItems:
                                                            "flex-start",
                                                          textAlign:
                                                            "-webkit-center",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Form.Item
                                                        className="kFormItem"
                                                        name="prooductdetail_937591_value"
                                                      >
                                                        <Image
                                                          key="937591"
                                                          id="937591"
                                                          value="[datafield:kapakResim]"
                                                          placeHolderImage="f4b5fbbd-9e25-402c-9581-08dd8e436860"
                                                          zoomOnClick={false}
                                                          imageFit="fit"
                                                          style={
                                                            {
                                                              borderTopLeftRadius: 10,
                                                              borderTopRightRadius: 10,
                                                              borderBottomRightRadius: 10,
                                                              borderBottomLeftRadius: 10,
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              width: "160px",
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        ></Image>
                                                      </Form.Item>
                                                    </KCol>
                                                  </KRow>
                                                  <KRow
                                                    key="255688"
                                                    id="255688"
                                                    align="top"
                                                    justify="start"
                                                    horizontalGutter={0}
                                                    verticalGutter={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <KCol
                                                      key="263405"
                                                      id="263405"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={24}
                                                      xxl={24}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 8,
                                                          paddingBottom: 8,
                                                          paddingLeft: 8,
                                                          alignItems:
                                                            "flex-start",
                                                          textAlign:
                                                            "-webkit-left",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Label
                                                        key="711225"
                                                        id="711225"
                                                        value="[datafield:tT_KODU]"
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 0,
                                                            paddingRight: 0,
                                                            paddingBottom: 0,
                                                            paddingLeft: 0,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Montserrat",
                                                            fontWeight: 500,
                                                            fontSize: "11px",
                                                            color:
                                                              "rgba(45, 45, 45, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                      <KCol
                                                        key="731535"
                                                        id="731535"
                                                        xs={24}
                                                        sm={24}
                                                        md={24}
                                                        lg={24}
                                                        xl={24}
                                                        xxl={24}
                                                        order={0}
                                                        pull={0}
                                                        push={0}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      >
                                                        <Label
                                                          key="96452"
                                                          id="96452"
                                                          onChange={(
                                                            e?: any
                                                          ) => {
                                                            if (
                                                              e &&
                                                              e.stopPropagation
                                                            )
                                                              e.stopPropagation();
                                                            this.prooductDetailComponent_96452_onChange();
                                                          }}
                                                          value="[datafield:birlesmisstok]"
                                                          maxLine={1}
                                                          tooltip="[datafield:birlesmisstok]"
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "10px",
                                                              color:
                                                                "rgba(45, 45, 45, 1)",
                                                            } as any
                                                          }
                                                        ></Label>
                                                      </KCol>
                                                    </KCol>
                                                  </KRow>
                                                  <KRow
                                                    key="197971"
                                                    id="197971"
                                                    align="top"
                                                    justify="start"
                                                    horizontalGutter={0}
                                                    verticalGutter={0}
                                                    style={
                                                      {
                                                        borderTopWidth: 1,
                                                        borderColor:
                                                          "rgba(244, 244, 244, 1)",
                                                        borderStyle: "solid",
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <KCol
                                                      key="614057"
                                                      id="614057"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={24}
                                                      xxl={24}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          textAlign:
                                                            "-webkit-left",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <KCol
                                                        key="351712"
                                                        id="351712"
                                                        xs={24}
                                                        sm={24}
                                                        md={24}
                                                        lg={24}
                                                        xl={24}
                                                        xxl={24}
                                                        order={0}
                                                        pull={0}
                                                        push={0}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      >
                                                        <KRow
                                                          key="848392"
                                                          id="848392"
                                                          align="top"
                                                          justify="start"
                                                          horizontalGutter={0}
                                                          verticalGutter={0}
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        >
                                                          <KCol
                                                            key="288469"
                                                            id="288469"
                                                            xs={24}
                                                            sm={24}
                                                            md={24}
                                                            lg={24}
                                                            xl={24}
                                                            xxl={24}
                                                            order={0}
                                                            pull={0}
                                                            push={0}
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 8,
                                                                paddingRight: 8,
                                                                paddingBottom: 20,
                                                                paddingLeft: 8,
                                                                alignItems:
                                                                  "flex-start",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "14px",
                                                                color:
                                                                  "rgba(68, 68, 68, 1)",
                                                              } as any
                                                            }
                                                          >
                                                            <Button
                                                              key="531437"
                                                              id="531437"
                                                              onClick={(
                                                                e?: any
                                                              ) => {
                                                                if (
                                                                  e &&
                                                                  e.stopPropagation
                                                                )
                                                                  e.stopPropagation();
                                                                this.prooductDetailComponent_531437_onClick();
                                                              }}
                                                              showCursorPointer
                                                              label={ReactSystemFunctions.translate(
                                                                this.ml,
                                                                531437,
                                                                "label",
                                                                this.defaultML
                                                              )}
                                                              size="middle"
                                                              loading={false}
                                                              ghost={false}
                                                              block={false}
                                                              htmlType="button"
                                                              iconPosition="left"
                                                              danger={false}
                                                              style={
                                                                {
                                                                  borderTopLeftRadius: 10,
                                                                  borderTopRightRadius: 10,
                                                                  borderBottomRightRadius: 10,
                                                                  borderBottomLeftRadius: 10,
                                                                  borderTopWidth: 1,
                                                                  borderRightWidth: 1,
                                                                  borderBottomWidth: 1,
                                                                  borderLeftWidth: 1,
                                                                  borderColor:
                                                                    "rgba(144, 144, 144, 0.15)",
                                                                  paddingTop: 8,
                                                                  paddingRight: 16,
                                                                  paddingBottom: 8,
                                                                  paddingLeft: 16,
                                                                  height:
                                                                    "35px",
                                                                  alignItems:
                                                                    "center",
                                                                  textAlign:
                                                                    "-webkit-center",
                                                                  display:
                                                                    "inline",
                                                                  fontFamily:
                                                                    "Poppins",
                                                                  fontWeight: 400,
                                                                  fontSize:
                                                                    "10px",
                                                                  color:
                                                                    "rgba(0, 0, 0, 1)",
                                                                  lineHeight:
                                                                    "5px",
                                                                } as any
                                                              }
                                                            ></Button>
                                                          </KCol>
                                                        </KRow>
                                                      </KCol>
                                                    </KCol>
                                                  </KRow>
                                                  <KRow
                                                    key="840191"
                                                    id="840191"
                                                    align="top"
                                                    justify="start"
                                                    horizontalGutter={0}
                                                    verticalGutter={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></KRow>
                                                </KCol>
                                              </KRow>
                                            </KCol>
                                          </KRow>
                                        </KGallery>
                                      </KTabItem>
                                      <KTabItem
                                        key={206560}
                                        id="206560"
                                        visibility={
                                          this.state.isComp206560Visible
                                        }
                                        tab={ReactSystemFunctions.translate(
                                          this.ml,
                                          206560,
                                          "tab",
                                          this.defaultML
                                        )}
                                        forceRender={true}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            backgroundColor:
                                              "rgba(255, 255, 255, 1)",
                                            backgroundRepeat: "no-repeat",
                                            backgroundSize: "contain",
                                            backgroundPosition: "left",
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KGallery
                                          key="787969"
                                          id="787969"
                                          kuikaRef={
                                            this
                                              .prooductdetail_787969_value_kuikaGalleryViewRef
                                          }
                                          nodatafoundmessage={ReactSystemFunctions.translate(
                                            this.ml,
                                            787969,
                                            "nodatafoundmessage",
                                            this.defaultML
                                          )}
                                          dataSource={
                                            this.state.GetKullanildigiUrunler
                                          }
                                          loading={false}
                                          phoneColumnsCount={1}
                                          tabletColumnsCount={2}
                                          desktopColumnsCount={6}
                                          hoverFontColor="black"
                                          hoverBgColor="white"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          showNoDataFoundImage={false}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KRow
                                            key="958659"
                                            id="958659"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="775633"
                                              id="775633"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={24}
                                              xxl={24}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 0,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="359590"
                                                id="359590"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="738310"
                                                  id="738310"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={24}
                                                  xxl={24}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 15,
                                                      borderTopRightRadius: 15,
                                                      borderBottomRightRadius: 15,
                                                      borderBottomLeftRadius: 15,
                                                      borderColor:
                                                        "rgba(72, 72, 72, 1)",
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 0,
                                                      alignItems: "flex-start",
                                                      textAlign: "-webkit-left",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <KRow
                                                    key="95673"
                                                    id="95673"
                                                    align="top"
                                                    justify="start"
                                                    horizontalGutter={0}
                                                    verticalGutter={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <KCol
                                                      key="613904"
                                                      id="613904"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={24}
                                                      xxl={24}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderTopLeftRadius: 15,
                                                          borderTopRightRadius: 15,
                                                          borderBottomRightRadius: 15,
                                                          borderBottomLeftRadius: 15,
                                                          borderTopWidth: 1,
                                                          borderRightWidth: 1,
                                                          borderBottomWidth: 1,
                                                          borderLeftWidth: 1,
                                                          borderColor:
                                                            "rgba(217, 217, 217, 0.37)",
                                                          borderStyle: "solid",
                                                          paddingTop: 0,
                                                          paddingRight: 8,
                                                          paddingBottom: 8,
                                                          paddingLeft: 8,
                                                          alignItems:
                                                            "flex-start",
                                                          textAlign:
                                                            "-webkit-center",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Form.Item
                                                        className="kFormItem"
                                                        name="prooductdetail_496425_value"
                                                      >
                                                        <Image
                                                          key="496425"
                                                          id="496425"
                                                          value="[datafield:kapakResim]"
                                                          placeHolderImage="f4b5fbbd-9e25-402c-9581-08dd8e436860"
                                                          zoomOnClick={false}
                                                          imageFit="fit"
                                                          style={
                                                            {
                                                              borderTopLeftRadius: 10,
                                                              borderTopRightRadius: 10,
                                                              borderBottomRightRadius: 10,
                                                              borderBottomLeftRadius: 10,
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              width: "160px",
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        ></Image>
                                                      </Form.Item>
                                                    </KCol>
                                                  </KRow>
                                                  <KRow
                                                    key="365271"
                                                    id="365271"
                                                    align="top"
                                                    justify="start"
                                                    horizontalGutter={0}
                                                    verticalGutter={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <KCol
                                                      key="772868"
                                                      id="772868"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={24}
                                                      xxl={24}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 8,
                                                          paddingBottom: 8,
                                                          paddingLeft: 8,
                                                          alignItems:
                                                            "flex-start",
                                                          textAlign:
                                                            "-webkit-left",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Label
                                                        key="517755"
                                                        id="517755"
                                                        value="[datafield:stoK_KODU]"
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 0,
                                                            paddingRight: 0,
                                                            paddingBottom: 0,
                                                            paddingLeft: 0,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Montserrat",
                                                            fontWeight: 500,
                                                            fontSize: "11px",
                                                            color:
                                                              "rgba(45, 45, 45, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                      <KCol
                                                        key="821591"
                                                        id="821591"
                                                        xs={24}
                                                        sm={24}
                                                        md={24}
                                                        lg={24}
                                                        xl={24}
                                                        xxl={24}
                                                        order={0}
                                                        pull={0}
                                                        push={0}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      >
                                                        <Label
                                                          key="309510"
                                                          id="309510"
                                                          onChange={(
                                                            e?: any
                                                          ) => {
                                                            if (
                                                              e &&
                                                              e.stopPropagation
                                                            )
                                                              e.stopPropagation();
                                                            this.prooductDetailComponent_309510_onChange();
                                                          }}
                                                          value="[datafield:birlesmisstok]"
                                                          maxLine={1}
                                                          tooltip="[datafield:birlesmisstok]"
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "10px",
                                                              color:
                                                                "rgba(45, 45, 45, 1)",
                                                            } as any
                                                          }
                                                        ></Label>
                                                      </KCol>
                                                    </KCol>
                                                    <KCol
                                                      key="796787"
                                                      id="796787"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={24}
                                                      xxl={24}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderTopWidth: 1,
                                                          borderColor:
                                                            "rgba(244, 244, 244, 1)",
                                                          borderStyle: "solid",
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 8,
                                                          paddingRight: 8,
                                                          paddingBottom: 20,
                                                          paddingLeft: 8,
                                                          alignItems:
                                                            "flex-start",
                                                          textAlign:
                                                            "-webkit-left",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Button
                                                        key="617138"
                                                        id="617138"
                                                        onClick={(e?: any) => {
                                                          if (
                                                            e &&
                                                            e.stopPropagation
                                                          )
                                                            e.stopPropagation();
                                                          this.prooductDetailComponent_617138_onClick();
                                                        }}
                                                        showCursorPointer
                                                        label={ReactSystemFunctions.translate(
                                                          this.ml,
                                                          617138,
                                                          "label",
                                                          this.defaultML
                                                        )}
                                                        size="middle"
                                                        loading={false}
                                                        ghost={false}
                                                        block={false}
                                                        htmlType="button"
                                                        iconPosition="left"
                                                        danger={false}
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 10,
                                                            borderTopRightRadius: 10,
                                                            borderBottomRightRadius: 10,
                                                            borderBottomLeftRadius: 10,
                                                            borderTopWidth: 1,
                                                            borderRightWidth: 1,
                                                            borderBottomWidth: 1,
                                                            borderLeftWidth: 1,
                                                            borderColor:
                                                              "rgba(144, 144, 144, 0.15)",
                                                            paddingTop: 8,
                                                            paddingRight: 16,
                                                            paddingBottom: 8,
                                                            paddingLeft: 16,
                                                            height: "35px",
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-center",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "10px",
                                                            color:
                                                              "rgba(0, 0, 0, 1)",
                                                            lineHeight: "5px",
                                                          } as any
                                                        }
                                                      ></Button>
                                                    </KCol>
                                                  </KRow>
                                                  <KRow
                                                    key="573404"
                                                    id="573404"
                                                    align="top"
                                                    justify="start"
                                                    horizontalGutter={0}
                                                    verticalGutter={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></KRow>
                                                </KCol>
                                              </KRow>
                                            </KCol>
                                          </KRow>
                                        </KGallery>
                                      </KTabItem>
                                      <KTabItem
                                        key={203933}
                                        id="203933"
                                        visibility={
                                          this.state.isComp203933Visible
                                        }
                                        tab={ReactSystemFunctions.translate(
                                          this.ml,
                                          203933,
                                          "tab",
                                          this.defaultML
                                        )}
                                        forceRender={true}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            backgroundColor:
                                              "rgba(255, 255, 255, 1)",
                                            backgroundRepeat: "no-repeat",
                                            backgroundSize: "contain",
                                            backgroundPosition: "left",
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KGallery
                                          key="79661"
                                          id="79661"
                                          kuikaRef={
                                            this
                                              .prooductdetail_79661_value_kuikaGalleryViewRef
                                          }
                                          nodatafoundmessage={ReactSystemFunctions.translate(
                                            this.ml,
                                            79661,
                                            "nodatafoundmessage",
                                            this.defaultML
                                          )}
                                          dataSource={
                                            this.state.GetKullanildigiAraclar
                                          }
                                          loading={false}
                                          phoneColumnsCount={1}
                                          tabletColumnsCount={2}
                                          desktopColumnsCount={1}
                                          hoverFontColor="black"
                                          hoverBgColor="white"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          showNoDataFoundImage={false}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KRow
                                            key="50379"
                                            id="50379"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="328090"
                                              id="328090"
                                              xs={12}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={12}
                                              xxl={12}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderTopLeftRadius: 15,
                                                  borderBottomLeftRadius: 15,
                                                  borderTopWidth: 1,
                                                  borderBottomWidth: 1,
                                                  borderLeftWidth: 1,
                                                  borderColor:
                                                    "rgba(217, 217, 217, 0.29)",
                                                  borderStyle: "solid",
                                                  borderRightWidth: 0,
                                                  backgroundColor:
                                                    "rgba(244, 244, 244, 1)",
                                                  backgroundRepeat: "no-repeat",
                                                  backgroundSize: "contain",
                                                  backgroundPosition: "left",
                                                  paddingTop: 8,
                                                  paddingRight: 0,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="97295"
                                                id="97295"
                                                value="[datafield:marka]"
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 5,
                                                    paddingRight: 5,
                                                    paddingBottom: 5,
                                                    paddingLeft: 5,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 600,
                                                    fontSize: "10px",
                                                    color: "rgba(0, 0, 0, 1)",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                            <KCol
                                              key="56207"
                                              id="56207"
                                              xs={12}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={12}
                                              xxl={12}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderTopRightRadius: 15,
                                                  borderBottomRightRadius: 15,
                                                  borderTopWidth: 1,
                                                  borderRightWidth: 1,
                                                  borderBottomWidth: 1,
                                                  borderColor:
                                                    "rgba(217, 217, 217, 0.29)",
                                                  borderStyle: "solid",
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 0,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="557836"
                                                id="557836"
                                                value="[datafield:model]"
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 5,
                                                    paddingRight: 5,
                                                    paddingBottom: 5,
                                                    paddingLeft: 10,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color: "rgba(0, 0, 0, 1)",
                                                  } as any
                                                }
                                              ></Label>
                                              <Label
                                                key="107346"
                                                id="107346"
                                                value="[datafield:motor]"
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 5,
                                                    paddingRight: 5,
                                                    paddingBottom: 5,
                                                    paddingLeft: 10,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color: "rgba(0, 0, 0, 1)",
                                                  } as any
                                                }
                                              ></Label>
                                            </KCol>
                                          </KRow>
                                        </KGallery>
                                      </KTabItem>
                                      <KTabItem
                                        key={397200}
                                        id="397200"
                                        visibility={
                                          this.state.isComp397200Visible
                                        }
                                        tab={ReactSystemFunctions.translate(
                                          this.ml,
                                          397200,
                                          "tab",
                                          this.defaultML
                                        )}
                                        forceRender={true}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            backgroundColor:
                                              "rgba(255, 255, 255, 1)",
                                            backgroundRepeat: "no-repeat",
                                            backgroundSize: "contain",
                                            backgroundPosition: "left",
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KGallery
                                          key="196525"
                                          id="196525"
                                          kuikaRef={
                                            this
                                              .prooductdetail_196525_value_kuikaGalleryViewRef
                                          }
                                          nodatafoundmessage={ReactSystemFunctions.translate(
                                            this.ml,
                                            196525,
                                            "nodatafoundmessage",
                                            this.defaultML
                                          )}
                                          dataSource={
                                            this.state.GetAlternatifUrun
                                          }
                                          loading={false}
                                          phoneColumnsCount={1}
                                          tabletColumnsCount={2}
                                          desktopColumnsCount={6}
                                          hoverFontColor="black"
                                          hoverBgColor="white"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          showNoDataFoundImage={false}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KRow
                                            key="983760"
                                            id="983760"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="561382"
                                              id="561382"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={24}
                                              xxl={24}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 0,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="96540"
                                                id="96540"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="996874"
                                                  id="996874"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={24}
                                                  xxl={24}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 15,
                                                      borderTopRightRadius: 15,
                                                      borderBottomRightRadius: 15,
                                                      borderBottomLeftRadius: 15,
                                                      borderColor:
                                                        "rgba(72, 72, 72, 1)",
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 0,
                                                      alignItems: "flex-start",
                                                      textAlign: "-webkit-left",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <KRow
                                                    key="270302"
                                                    id="270302"
                                                    align="top"
                                                    justify="start"
                                                    horizontalGutter={0}
                                                    verticalGutter={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <KCol
                                                      key="729974"
                                                      id="729974"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={24}
                                                      xxl={24}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderTopLeftRadius: 15,
                                                          borderTopRightRadius: 15,
                                                          borderBottomRightRadius: 15,
                                                          borderBottomLeftRadius: 15,
                                                          borderTopWidth: 1,
                                                          borderRightWidth: 1,
                                                          borderBottomWidth: 1,
                                                          borderLeftWidth: 1,
                                                          borderColor:
                                                            "rgba(217, 217, 217, 0.37)",
                                                          borderStyle: "solid",
                                                          paddingTop: 0,
                                                          paddingRight: 8,
                                                          paddingBottom: 8,
                                                          paddingLeft: 8,
                                                          alignItems:
                                                            "flex-start",
                                                          textAlign:
                                                            "-webkit-center",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Form.Item
                                                        className="kFormItem"
                                                        name="prooductdetail_104750_value"
                                                      >
                                                        <Image
                                                          key="104750"
                                                          id="104750"
                                                          value="[datafield:kapakResim]"
                                                          placeHolderImage="f4b5fbbd-9e25-402c-9581-08dd8e436860"
                                                          zoomOnClick={false}
                                                          imageFit="fit"
                                                          style={
                                                            {
                                                              borderTopLeftRadius: 10,
                                                              borderTopRightRadius: 10,
                                                              borderBottomRightRadius: 10,
                                                              borderBottomLeftRadius: 10,
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              width: "160px",
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        ></Image>
                                                      </Form.Item>
                                                    </KCol>
                                                  </KRow>
                                                  <KRow
                                                    key="852760"
                                                    id="852760"
                                                    align="top"
                                                    justify="start"
                                                    horizontalGutter={0}
                                                    verticalGutter={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <KCol
                                                      key="754459"
                                                      id="754459"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={24}
                                                      xxl={24}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 8,
                                                          paddingBottom: 8,
                                                          paddingLeft: 8,
                                                          alignItems:
                                                            "flex-start",
                                                          textAlign:
                                                            "-webkit-left",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Label
                                                        key="690845"
                                                        id="690845"
                                                        value="[datafield:anA_URUN]"
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 0,
                                                            paddingRight: 0,
                                                            paddingBottom: 0,
                                                            paddingLeft: 0,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Montserrat",
                                                            fontWeight: 500,
                                                            fontSize: "11px",
                                                            color:
                                                              "rgba(45, 45, 45, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                      <KCol
                                                        key="109384"
                                                        id="109384"
                                                        xs={24}
                                                        sm={24}
                                                        md={24}
                                                        lg={24}
                                                        xl={24}
                                                        xxl={24}
                                                        order={0}
                                                        pull={0}
                                                        push={0}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      >
                                                        <Label
                                                          key="220309"
                                                          id="220309"
                                                          onChange={(
                                                            e?: any
                                                          ) => {
                                                            if (
                                                              e &&
                                                              e.stopPropagation
                                                            )
                                                              e.stopPropagation();
                                                            this.prooductDetailComponent_220309_onChange();
                                                          }}
                                                          value="[datafield:birlesmisstok]"
                                                          maxLine={1}
                                                          tooltip="[datafield:birlesmisstok]"
                                                          writingMode="horizontal"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "10px",
                                                              color:
                                                                "rgba(45, 45, 45, 1)",
                                                            } as any
                                                          }
                                                        ></Label>
                                                      </KCol>
                                                    </KCol>
                                                    <KCol
                                                      key="315204"
                                                      id="315204"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={24}
                                                      xxl={24}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderTopWidth: 1,
                                                          borderColor:
                                                            "rgba(244, 244, 244, 1)",
                                                          borderStyle: "solid",
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 8,
                                                          paddingRight: 8,
                                                          paddingBottom: 20,
                                                          paddingLeft: 8,
                                                          alignItems:
                                                            "flex-start",
                                                          textAlign:
                                                            "-webkit-left",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Button
                                                        key="241943"
                                                        id="241943"
                                                        onClick={(e?: any) => {
                                                          if (
                                                            e &&
                                                            e.stopPropagation
                                                          )
                                                            e.stopPropagation();
                                                          this.prooductDetailComponent_241943_onClick();
                                                        }}
                                                        showCursorPointer
                                                        label={ReactSystemFunctions.translate(
                                                          this.ml,
                                                          241943,
                                                          "label",
                                                          this.defaultML
                                                        )}
                                                        size="middle"
                                                        loading={false}
                                                        ghost={false}
                                                        block={false}
                                                        htmlType="button"
                                                        iconPosition="left"
                                                        danger={false}
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 10,
                                                            borderTopRightRadius: 10,
                                                            borderBottomRightRadius: 10,
                                                            borderBottomLeftRadius: 10,
                                                            borderTopWidth: 1,
                                                            borderRightWidth: 1,
                                                            borderBottomWidth: 1,
                                                            borderLeftWidth: 1,
                                                            borderColor:
                                                              "rgba(144, 144, 144, 0.15)",
                                                            paddingTop: 8,
                                                            paddingRight: 16,
                                                            paddingBottom: 8,
                                                            paddingLeft: 16,
                                                            height: "35px",
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-center",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "10px",
                                                            color:
                                                              "rgba(0, 0, 0, 1)",
                                                            lineHeight: "5px",
                                                          } as any
                                                        }
                                                      ></Button>
                                                    </KCol>
                                                  </KRow>
                                                  <KRow
                                                    key="912852"
                                                    id="912852"
                                                    align="top"
                                                    justify="start"
                                                    horizontalGutter={0}
                                                    verticalGutter={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></KRow>
                                                </KCol>
                                              </KRow>
                                            </KCol>
                                          </KRow>
                                        </KGallery>
                                      </KTabItem>
                                      <KTabItem
                                        key={801000}
                                        id="801000"
                                        visibility={
                                          this.state.isComp801000Visible
                                        }
                                        tab={ReactSystemFunctions.translate(
                                          this.ml,
                                          801000,
                                          "tab",
                                          this.defaultML
                                        )}
                                        forceRender={true}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            backgroundColor:
                                              "rgba(255, 255, 255, 1)",
                                            backgroundRepeat: "no-repeat",
                                            backgroundSize: "contain",
                                            backgroundPosition: "left",
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KRow
                                          key="434755"
                                          id="434755"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="647824"
                                            id="647824"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={24}
                                            xxl={24}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <KGallery
                                              key="318215"
                                              id="318215"
                                              kuikaRef={
                                                this
                                                  .prooductdetail_318215_value_kuikaGalleryViewRef
                                              }
                                              nodatafoundmessage={ReactSystemFunctions.translate(
                                                this.ml,
                                                318215,
                                                "nodatafoundmessage",
                                                this.defaultML
                                              )}
                                              dataSource={
                                                this.state.GetTeknikOzellikler
                                              }
                                              loading={false}
                                              phoneColumnsCount={1}
                                              tabletColumnsCount={2}
                                              desktopColumnsCount={2}
                                              hoverFontColor="black"
                                              hoverBgColor="white"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              showNoDataFoundImage={false}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="30027"
                                                id="30027"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="665321"
                                                  id="665321"
                                                  xs={12}
                                                  sm={12}
                                                  md={12}
                                                  lg={12}
                                                  xl={12}
                                                  xxl={12}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 15,
                                                      borderBottomLeftRadius: 15,
                                                      borderTopWidth: 1,
                                                      borderBottomWidth: 1,
                                                      borderLeftWidth: 1,
                                                      borderColor:
                                                        "rgba(217, 217, 217, 0.29)",
                                                      borderStyle: "solid",
                                                      borderRightWidth: 0,
                                                      backgroundColor:
                                                        "rgba(244, 244, 244, 1)",
                                                      backgroundRepeat:
                                                        "no-repeat",
                                                      backgroundSize: "contain",
                                                      backgroundPosition:
                                                        "left",
                                                      paddingTop: 8,
                                                      paddingRight: 0,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign: "-webkit-left",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="488520"
                                                    id="488520"
                                                    value="[datafield:tekniK_ACIKLAMA]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 5,
                                                        paddingRight: 5,
                                                        paddingBottom: 5,
                                                        paddingLeft: 5,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 600,
                                                        fontSize: "10px",
                                                        color:
                                                          "rgba(0, 0, 0, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KCol>
                                                <KCol
                                                  key="377732"
                                                  id="377732"
                                                  xs={12}
                                                  sm={12}
                                                  md={12}
                                                  lg={12}
                                                  xl={12}
                                                  xxl={12}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderTopRightRadius: 15,
                                                      borderBottomRightRadius: 15,
                                                      borderTopWidth: 1,
                                                      borderRightWidth: 1,
                                                      borderBottomWidth: 1,
                                                      borderColor:
                                                        "rgba(217, 217, 217, 0.29)",
                                                      borderStyle: "solid",
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 0,
                                                      alignItems: "flex-start",
                                                      textAlign: "-webkit-left",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="635821"
                                                    id="635821"
                                                    value="[datafield:deger]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 5,
                                                        paddingRight: 5,
                                                        paddingBottom: 5,
                                                        paddingLeft: 10,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(0, 0, 0, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KCol>
                                              </KRow>
                                            </KGallery>
                                          </KCol>
                                        </KRow>
                                      </KTabItem>
                                      <KTabItem
                                        key={720155}
                                        id="720155"
                                        visibility={
                                          this.state.isComp720155Visible
                                        }
                                        tab={ReactSystemFunctions.translate(
                                          this.ml,
                                          720155,
                                          "tab",
                                          this.defaultML
                                        )}
                                        forceRender={true}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            backgroundColor:
                                              "rgba(255, 255, 255, 1)",
                                            backgroundRepeat: "no-repeat",
                                            backgroundSize: "contain",
                                            backgroundPosition: "left",
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KRow
                                          key="966906"
                                          id="966906"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="769067"
                                            id="769067"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={24}
                                            xxl={24}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <KGallery
                                              key="923301"
                                              id="923301"
                                              kuikaRef={
                                                this
                                                  .prooductdetail_923301_value_kuikaGalleryViewRef
                                              }
                                              nodatafoundmessage={ReactSystemFunctions.translate(
                                                this.ml,
                                                923301,
                                                "nodatafoundmessage",
                                                this.defaultML
                                              )}
                                              dataSource={
                                                this.state.GetOemBilgileri
                                              }
                                              loading={false}
                                              phoneColumnsCount={1}
                                              tabletColumnsCount={2}
                                              desktopColumnsCount={2}
                                              hoverFontColor="black"
                                              hoverBgColor="white"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              showNoDataFoundImage={false}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="882345"
                                                id="882345"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="733638"
                                                  id="733638"
                                                  xs={12}
                                                  sm={12}
                                                  md={12}
                                                  lg={12}
                                                  xl={12}
                                                  xxl={12}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 15,
                                                      borderBottomLeftRadius: 15,
                                                      borderTopWidth: 1,
                                                      borderBottomWidth: 1,
                                                      borderLeftWidth: 1,
                                                      borderColor:
                                                        "rgba(217, 217, 217, 0.29)",
                                                      borderStyle: "solid",
                                                      borderRightWidth: 0,
                                                      backgroundColor:
                                                        "rgba(244, 244, 244, 1)",
                                                      backgroundRepeat:
                                                        "no-repeat",
                                                      backgroundSize: "contain",
                                                      backgroundPosition:
                                                        "left",
                                                      paddingTop: 8,
                                                      paddingRight: 0,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign: "-webkit-left",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="441147"
                                                    id="441147"
                                                    value="[datafield:musterI_MARKA]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 5,
                                                        paddingRight: 5,
                                                        paddingBottom: 5,
                                                        paddingLeft: 5,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 600,
                                                        fontSize: "10px",
                                                        color:
                                                          "rgba(0, 0, 0, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KCol>
                                                <KCol
                                                  key="878324"
                                                  id="878324"
                                                  xs={12}
                                                  sm={12}
                                                  md={12}
                                                  lg={12}
                                                  xl={12}
                                                  xxl={12}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderTopRightRadius: 15,
                                                      borderBottomRightRadius: 15,
                                                      borderTopWidth: 1,
                                                      borderRightWidth: 1,
                                                      borderBottomWidth: 1,
                                                      borderColor:
                                                        "rgba(217, 217, 217, 0.29)",
                                                      borderStyle: "solid",
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 0,
                                                      alignItems: "flex-start",
                                                      textAlign: "-webkit-left",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="821262"
                                                    id="821262"
                                                    value="[datafield:oeM_NO]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 5,
                                                        paddingRight: 5,
                                                        paddingBottom: 5,
                                                        paddingLeft: 10,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(0, 0, 0, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KCol>
                                              </KRow>
                                            </KGallery>
                                          </KCol>
                                        </KRow>
                                      </KTabItem>
                                    </KTab>
                                  </Form.Item>
                                </KCol>
                              </KRow>
                            </KCol>
                          </KRow>
                        </KCol>
                      </KRow>
                    </KCol>
                    <KCol
                      key="762220"
                      id="762220"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={3}
                      xxl={3}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    ></KCol>
                  </KRow>
                  <KRow
                    key="261413"
                    id="261413"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KCol
                      key="855206"
                      id="855206"
                      xs={8}
                      sm={8}
                      md={8}
                      lg={8}
                      xl={8}
                      xxl={8}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    ></KCol>
                    <KCol
                      key="475159"
                      id="475159"
                      xs={8}
                      sm={8}
                      md={8}
                      lg={8}
                      xl={8}
                      xxl={8}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    ></KCol>
                    <KCol
                      key="595344"
                      id="595344"
                      xs={8}
                      sm={8}
                      md={8}
                      lg={8}
                      xl={8}
                      xxl={8}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    ></KCol>
                  </KRow>
                  <KDrawer
                    key="146233"
                    id="146233"
                    placement="top"
                    onClose={() => {
                      this.setState({ NavVisible146233: false }, () => {
                        this.callCallbackFunction(146233);
                      });
                    }}
                    visible={this.state.NavVisible146233}
                    width="380px"
                    height="100vh"
                    push={true}
                    closable={true}
                    children={
                      this.state.NavVisible146233 && (
                        <InlineFormScope>
                          <ProoductDetail_Screen
                            onClose={() => {
                              this.setState({ NavVisible146233: false }, () => {
                                this.callCallbackFunction(146233);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  ></KDrawer>
                  <KDrawer
                    key="853774"
                    id="853774"
                    placement="top"
                    onClose={() => {
                      this.setState({ NavVisible853774: false }, () => {
                        this.callCallbackFunction(853774);
                      });
                    }}
                    visible={this.state.NavVisible853774}
                    width="380px"
                    height="100vh"
                    push={true}
                    closable={true}
                    children={
                      this.state.NavVisible853774 && (
                        <InlineFormScope>
                          <ProoductDetail_Screen
                            onClose={() => {
                              this.setState({ NavVisible853774: false }, () => {
                                this.callCallbackFunction(853774);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  ></KDrawer>
                  <KDrawer
                    key="669607"
                    id="669607"
                    placement="top"
                    onClose={() => {
                      this.setState({ NavVisible669607: false }, () => {
                        this.callCallbackFunction(669607);
                      });
                    }}
                    visible={this.state.NavVisible669607}
                    width="380px"
                    height="100vh"
                    push={true}
                    closable={true}
                    children={
                      this.state.NavVisible669607 && (
                        <InlineFormScope>
                          <ProoductDetail_Screen
                            onClose={() => {
                              this.setState({ NavVisible669607: false }, () => {
                                this.callCallbackFunction(669607);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  ></KDrawer>
                  <KModal
                    key="161263"
                    id="161263"
                    visible={this.state.NavVisible161263}
                    onOk={() => {
                      this.setState({ NavVisible161263: false }, () => {
                        this.callCallbackFunction(161263);
                      });
                    }}
                    onCancel={() => {
                      this.setState({ NavVisible161263: false }, () => {
                        this.callCallbackFunction(161263);
                      });
                    }}
                    closable={true}
                    width="400px"
                    footer={null}
                    height="38vh"
                    children={
                      this.state.NavVisible161263 && (
                        <InlineFormScope>
                          <SepetModal_Screen
                            onClose={() => {
                              this.setState({ NavVisible161263: false }, () => {
                                this.callCallbackFunction(161263);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                  ></KModal>
                  <KModal
                    key="122056"
                    id="122056"
                    visible={this.state.NavVisible122056}
                    onOk={() => {
                      this.setState({ NavVisible122056: false }, () => {
                        this.callCallbackFunction(122056);
                      });
                    }}
                    onCancel={() => {
                      this.setState({ NavVisible122056: false }, () => {
                        this.callCallbackFunction(122056);
                      });
                    }}
                    closable={true}
                    width="400px"
                    footer={null}
                    height="38vh"
                    children={
                      this.state.NavVisible122056 && (
                        <InlineFormScope>
                          <SepetModal_Screen
                            onClose={() => {
                              this.setState({ NavVisible122056: false }, () => {
                                this.callCallbackFunction(122056);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                  ></KModal>
                  <KDrawer
                    key="515106"
                    id="515106"
                    placement="top"
                    onClose={() => {
                      this.setState({ NavVisible515106: false }, () => {
                        this.callCallbackFunction(515106);
                      });
                    }}
                    visible={this.state.NavVisible515106}
                    width="380px"
                    height="100vh"
                    push={true}
                    closable={true}
                    children={
                      this.state.NavVisible515106 && (
                        <InlineFormScope>
                          <ProoductDetail_Screen
                            onClose={() => {
                              this.setState({ NavVisible515106: false }, () => {
                                this.callCallbackFunction(515106);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  ></KDrawer>
                </div>
              </div>
            </Form>
          </KuikaTabOrderProvider>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    spinnerCount: state.spinnerReducer.spinnerCount,
    photoTakeVisible: state.photoTakeReducer.visible,
    isImportMappedExcelModalVisible:
      state.importMappedExcelModalReducer.visible,
  };
};
const mapDispatchToProps = (dispatch) => ({
  showPhotoTake: () => dispatch(showPhotoTake()),
  hidePhotoTake: () => dispatch(hidePhotoTake()),
  showStripeDrawer: (data, callback, that, future) =>
    dispatch(showStripeDrawer(data, callback, that, future)),
  hideStripeDrawer: (data, callback, that) =>
    dispatch(hideStripeDrawer(data, callback, that)),
  showIyzicoDrawer: (data, callback, that) =>
    dispatch(showIyzicoDrawer(data, callback, that)),
  hideIyzicoDrawer: (data, callback, that) =>
    dispatch(hideIyzicoDrawer(data, callback, that)),
  showImportMappedExcelModal: (
    dsId,
    tableName,
    primaryKey,
    columnMapping,
    parameters
  ) =>
    dispatch(
      showImportMappedExcelModal(
        dsId,
        tableName,
        primaryKey,
        columnMapping,
        parameters
      )
    ),
  hideImportMappedExcelModal: () => dispatch(hideImportMappedExcelModal()),
});
const tmp = withGoogleLogin(
  withContext(
    withScreenInput(
      withForm(
        withHistory(
          withInlineOverlayNav(
            connect(mapStateToProps, mapDispatchToProps)(ProoductDetail_Screen)
          )
        )
      )
    )
  )
);
export { tmp as ProoductDetail_Screen };
//export default tmp;
//export { tmp as ProoductDetail_Screen };
